"use strict";

exports.__esModule = true;
exports.getMarkLinesOptions = void 0;
var _valueFormatters = require("../valueFormatters");
var STATISTICS_FONT_SIZE = 10;
var getMarkLinesOptions = exports.getMarkLinesOptions = function getMarkLinesOptions(statistics, chartItem, targetValue, valueFormatter, uiModern) {
  var _chartItem$lineTrends;
  if (valueFormatter === void 0) {
    valueFormatter = _valueFormatters.defaultValueFormatter;
  }
  if (uiModern === void 0) {
    uiModern = false;
  }
  var data = [];
  var parsedTargetValue = parseFloat(targetValue);
  if (statistics != null && statistics.avgShow) {
    data.push({
      symbol: "circle",
      type: "average",
      label: {
        formatter: function formatter(_ref) {
          var value = _ref.value;
          return "Avg: " + valueFormatter(value);
        },
        position: "end",
        fontSize: STATISTICS_FONT_SIZE
      }
    });
  }
  if (statistics != null && statistics.medShow) {
    data.push({
      symbol: "circle",
      type: "median",
      label: {
        formatter: function formatter(_ref2) {
          var value = _ref2.value;
          return "Med: " + valueFormatter(value);
        },
        position: "start",
        fontSize: STATISTICS_FONT_SIZE
      }
    });
  }
  chartItem == null || (_chartItem$lineTrends = chartItem.lineTrends) == null || _chartItem$lineTrends.forEach(function (lineTrend) {
    data.push({
      yAxis: lineTrend == null ? void 0 : lineTrend.value,
      lineStyle: {
        color: lineTrend == null ? void 0 : lineTrend.color
      },
      label: {
        formatter: function formatter(_ref3) {
          var value = _ref3.value;
          return valueFormatter(value);
        }
      }
    });
  });
  if (!isNaN(parsedTargetValue)) {
    data.push({
      yAxis: parsedTargetValue,
      lineStyle: {
        color: uiModern ? "#3D4A53" : "#333333"
      },
      label: {
        formatter: function formatter(_ref4) {
          var value = _ref4.value;
          return valueFormatter(value);
        }
      }
    });
  }
  return {
    data: data
  };
};